import axios from 'axios';
import { CONFIG } from '@/config/Config';
import { addSessionId } from '@/core/utils/httpHeaders';
import { getAccountId, getUniId } from '@/core/utils/extractCookieId';

interface RawRoutingSetting {
  id?: string | number;
  name?: string;
}

interface RoutingApiResponse {
  data?: unknown[];
  message?: {
    data?: unknown[];
  };
}

export interface ConversationRoutingSetting {
  id: string;
  name: string;
}

const getRoutingSource = (payload: unknown): unknown[] => {
  if (!payload || typeof payload !== 'object') return [];

  const objectPayload = payload as RoutingApiResponse;
  if (Array.isArray(objectPayload.data)) {
    return objectPayload.data;
  }

  if (Array.isArray(objectPayload.message?.data)) {
    return objectPayload.message.data;
  }

  return [];
};

const mapRawRoutingSetting = (raw: unknown): ConversationRoutingSetting | null => {
  if (!raw || typeof raw !== 'object') return null;

  const setting = raw as RawRoutingSetting;
  const id = String(setting.id ?? '').trim();
  const name = String(setting.name ?? '').trim();

  if (!id || !name) return null;

  return { id, name };
};

export async function fetchConversationRoutingByAccount(): Promise<ConversationRoutingSetting[]> {
  const accountId = getAccountId();
  const universeId = getUniId();

  if (!accountId || !universeId || accountId === 'DEFAULT' || universeId === 'DEFAULT') {
    console.warn('account_id or universe_id is undefined, skipping fetchConversationRoutingByAccount');
    return [];
  }

  const url = `${CONFIG.getGatewayUrl()}sac-router/${CONFIG.getVersion()}/router/setting`;

  const headers = addSessionId({
    accept: 'application/json',
  });

  const response = await axios.get(url, {
    headers,
    params: {
      account_id: accountId,
      universe_id: universeId,
    },
  });

  const mapped = getRoutingSource(response.data)
    .map(mapRawRoutingSetting)
    .filter(Boolean) as ConversationRoutingSetting[];

  const dedupedById = new Map<string, ConversationRoutingSetting>();
  mapped.forEach((item) => {
    if (!dedupedById.has(item.id)) {
      dedupedById.set(item.id, item);
    }
  });

  return Array.from(dedupedById.values());
}